(() => {
  const hashUpdateListener = () => {
    const accordionEl = document.getElementById('accordion-v2') || document.querySelector(".b-accordion-list")
    const locationHash = window.location.hash
    if(accordionEl && locationHash) {
      const accordionSingleEl = accordionEl.querySelector(`[data-accordion-trigger=${locationHash.replace("#",'')} i]`) || accordionEl.querySelector(`[id=${locationHash.replace("#",'')} i]`)
      accordionSingleEl?.click()
      accordionSingleEl?.scrollIntoView()
    }
  }
  
  window.onhashchange = hashUpdateListener;
  if (/complete|interactive|loaded/.test(document.readyState)) {
      hashUpdateListener()
  } else {
      window.addEventListener("load", hashUpdateListener);
  }
  
})();